// ═══════════════════════════════════════════════════════════════════════════
// Resolución de precios
//
// Extraído literal de index.html v0.9.16 (getPrice, línea 2579).
// NO cambiar el comportamiento: la Etapa 2 es refactor, no mejora.
// ═══════════════════════════════════════════════════════════════════════════

export const PRICING_RULES = {
  default:     { label: "Precio estándar",              priceMap: null },
  vinopremier: { label: "Precio Vinopremier (mayoreo)", priceMap: null },
  sacacorchos: { label: "Precio Sacacorchos",           priceMap: null },
  custom:      { label: "Precio personalizado",         priceMap: null },
};

/**
 * Instala los mapas de precio. En el monolito eran constantes del código
 * (VINOPREMIER_PRICES / SACACORCHOS_PRICES); aquí se inyectan para que en la
 * Etapa 4 puedan venir de la base de datos sin tocar esta lógica.
 */
export function instalarMapas({ vinopremier, sacacorchos }) {
  PRICING_RULES.vinopremier.priceMap = vinopremier || null;
  PRICING_RULES.sacacorchos.priceMap = sacacorchos || null;
}

/**
 * Precio de un producto para un cliente.
 * Orden: precio personalizado del cliente → mapa de su regla → precio base.
 */
export function resolverPrecio(productId, client, products) {
  if (!client) return products.find(p => p.id === productId)?.grossPrice || 0;

  if (client.customPrices &&
      client.customPrices[productId] !== undefined &&
      client.customPrices[productId] !== "") {
    return Number(client.customPrices[productId]);
  }

  const rule = PRICING_RULES[client.pricingRule];
  if (rule?.priceMap && rule.priceMap[productId] !== undefined) {
    return rule.priceMap[productId];
  }

  return products.find(p => p.id === productId)?.grossPrice || 0;
}

/** Devuelve una función getPrice(productId) ligada a un cliente y catálogo. */
export function crearGetPrice(client, products) {
  return (productId) => resolverPrecio(productId, client, products);
}
